"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var meta_field_1 = require("../model/meta-field");
var core_1 = require("@angular/core");
/**
 * Created by anania.mikaelyan on 11/30/16.
 */
var MetaFieldTypeHelper = /** @class */ (function () {
    function MetaFieldTypeHelper() {
        this.MetaFieldTypes = new Map();
        this.MetaFieldTypes.set("INTEGER_IDENTITY", meta_field_1.MetaFieldType.INTEGER_IDENTITY);
        this.MetaFieldTypes.set("INTEGER", meta_field_1.MetaFieldType.INTEGER);
        this.MetaFieldTypes.set("DOUBLE", meta_field_1.MetaFieldType.DECIMAL);
        this.MetaFieldTypes.set("BIG_DECIMAL", meta_field_1.MetaFieldType.BIG_DECIMAL);
        this.MetaFieldTypes.set("INTEGER_INSTANCE", meta_field_1.MetaFieldType.INTEGER_INSTANCE);
        this.MetaFieldTypes.set("STRING", meta_field_1.MetaFieldType.STRING);
        this.MetaFieldTypes.set("MULTILINGUAL_STRING", meta_field_1.MetaFieldType.MULTILINGUAL_STRING);
        this.MetaFieldTypes.set("DATE", meta_field_1.MetaFieldType.DATE);
        this.MetaFieldTypes.set("DATE_TIME", meta_field_1.MetaFieldType.DATE_TIME);
        this.MetaFieldTypes.set("BOOLEAN", meta_field_1.MetaFieldType.BOOLEAN);
        this.MetaFieldTypes.set("CLASSIFIER", meta_field_1.MetaFieldType.CLASSIFIER);
        this.MetaFieldTypes.set("DOCUMENT", meta_field_1.MetaFieldType.DOCUMENT);
        this.MetaFieldTypes.set("PARENT", meta_field_1.MetaFieldType.PARENT);
        this.MetaFieldTypes.set("MULTI_SELECT", meta_field_1.MetaFieldType.MULTI_SELECT);
        this.MetaFieldTypes.set("SUB_ENTITY", meta_field_1.MetaFieldType.SUB_ENTITY);
        this.MetaFieldTypes.set("MAIN_ENTITY", meta_field_1.MetaFieldType.MAIN_ENTITY);
        this.MetaFieldTypes.set("WORKFLOW_STATE", meta_field_1.MetaFieldType.WORKFLOW_STATE);
        this.MetaFieldTypes.set("USER", meta_field_1.MetaFieldType.USER);
        this.MetaFieldTypes.set("LOCAL_DATE", meta_field_1.MetaFieldType.LOCAL_DATE);
        this.MetaFieldTypes.set("LOCAL_DATE_TIME", meta_field_1.MetaFieldType.LOCAL_DATE_TIME);
        this.MetaFieldTypes.set("MONEY", meta_field_1.MetaFieldType.MONEY);
        this.MetaFieldTypes.set("ACCOUNTING", meta_field_1.MetaFieldType.ACCOUNTING);
        this.MetaFieldTypes.set("LOOKUP", meta_field_1.MetaFieldType.LOOKUP);
    }
    MetaFieldTypeHelper.prototype.getMetaFieldType = function (MetaFieldTypeStr) {
        return this.MetaFieldTypes.get(MetaFieldTypeStr);
    };
    MetaFieldTypeHelper = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], MetaFieldTypeHelper);
    return MetaFieldTypeHelper;
}());
exports.MetaFieldTypeHelper = MetaFieldTypeHelper;
//# sourceMappingURL=meta-field-type-helper.js.map